import { Slot, useLocalSearchParams } from "expo-router";
import { BlurredBackground } from "ui";

import { DeliveryStatusProvider } from "@/src/contexts/delivery-status-context";

export default function Layout() {
  const { uuid } = useLocalSearchParams<{ uuid: string }>();

  return (
    <DeliveryStatusProvider uuid={uuid}>
      <BlurredBackground>
        <Slot />
      </BlurredBackground>
    </DeliveryStatusProvider>
  );
}
